import Edge from '../../../components/Edge/Edge.view'

const edgeTypes = {
  dataflow: Edge
}

export default edgeTypes
